import React from 'react';
import { Button, Box, Text } from '@goodrx/matisse';
import { useSynapse } from 'app/lib/synaptik';
import { useHistory } from 'react-router-dom';
import { Breakpoints } from 'app/config/constants';
import { onTriageCtaInteraction } from 'app/lib/analytics';
import { DiagnoseCondition } from 'app/types/Infermedica';
import { TriageBlockConfig } from '../TriageBlock';
import { SenderChatBubble } from '../shared';

type DisqualifyBlockData = {
  conditions: DiagnoseCondition[];
};

export const code: TriageBlockConfig['code'] = 'disqualify';

export const Message: TriageBlockConfig<DisqualifyBlockData>['Message'] = ({ sessionId }) => {
  const history = useHistory();
  const firstName = useSynapse(({ user }) => user.state.profile?.firstName);

  const handleLeaveTriage = () => {
    sessionStorage.removeItem('triageCache');
    sessionStorage.removeItem('stateSelection');
    history.replace('/account');
    onTriageCtaInteraction({ type: 'exit-chat', sessionId });
  };

  return (
    <Box flex={1}>
      <SenderChatBubble>
        Thanks {firstName}! It looks like you may be experiencing something which we do not yet treat at HeyDoctor.
      </SenderChatBubble>

      <SenderChatBubble>
        As a reminder, this is not a diagnosis or medical advice and your responses have not yet been seen by a
        healthcare provider. Please seek immediate medical care if your symptoms seem serious.
      </SenderChatBubble>

      <SenderChatBubble>
        For other telemedicine resources that may be able to help, check out the{' '}
        <Text fontWeight={600}>GoodRx Marketplace.</Text>
      </SenderChatBubble>

      <SenderChatBubble>When you’re ready, click Exit Chat to return back to HeyDoctor.</SenderChatBubble>

      <Button.Group vertical={Breakpoints.md}>
        <Button
          as="a"
          mt={2}
          variant="primary"
          block
          onClick={() => onTriageCtaInteraction({ type: 'view-goodrx-marketplace', sessionId })}
          href="https://www.goodrx.com/treatment"
          target="_blank"
          rel="noopener noreferrer"
          data-qa="open-goodrx-marketplace-btn">
          Open GoodRx Marketplace
        </Button>

        <Button mt={2} variant="secondary" onClick={handleLeaveTriage} block data-qa="exit-chat-btn">
          Exit Chat
        </Button>
      </Button.Group>
    </Box>
  );
};

export const Response = () => null;

export const SavedResponse = () => null;
